<template>
    <Page
        v-if="total>10"
        :current="pageNumber"
        :total="total"
        :page-size="pageSize"
        @on-change="changePage"
        @on-page-size-change="changePageSize"
        :page-size-opts="[10, 20, 50]"
        size="small"
        show-total
        show-elevator
        show-sizer
    ></Page>
</template>
<script>
export default {
    props:{
        //当前页
        pageNumber:{
            type:Number,
            required:true
        },
        //总条数
        total:{
            type:Number,
            required:true
        },
        //每页显示条数
        pageSize:{
            type:Number,
            required:true,
            default:10
        }
    },
    methods:{
        changePage(value){
            this.$emit('changPage',value)
        },
        changePageSize(value){
            this.$emit('changePageSize',value)
        }
    }
}
</script>

